import { CancelButton, ConfirmButton } from 'components/button/button.styled'
import { ProgressSpinner } from 'primereact/progressspinner'
import { BaseSyntheticEvent, ReactNode, useRef } from 'react'

import { ButtonContainer, ButtonWrapper, FormContainer } from './form.style'

interface CustomFormProps {
    handleSubmit: (e?: BaseSyntheticEvent<object, any, any> | undefined) => Promise<void>
    loading: boolean
    initialData?: any
    onClose: (() => void) | undefined
    onSuccess?: () => void
    children: ReactNode
    hasLine?: boolean
    disableButtons?: boolean
    formRef?: React.RefObject<HTMLFormElement>
}

export const CustomForm = ({
    handleSubmit,
    loading,
    initialData,
    onClose,
    onSuccess,
    children,
    hasLine = true,
    disableButtons = false,
    formRef,
}: CustomFormProps) => {
    const localFormRef = useRef<HTMLFormElement>(null)

    const handleFormSubmit = async (e?: BaseSyntheticEvent<object, any, any>) => {
        try {
            if (e) e.preventDefault()
            await handleSubmit(e)
            if (onSuccess) {
                onSuccess()
            }
        } catch (error) {
            console.error('Form submission error:', error)
        }
    }

    return (
        <FormContainer onSubmit={handleFormSubmit} ref={formRef ?? localFormRef}>
            <div className="p-fluid">
                {loading ? (
                    <ProgressSpinner />
                ) : (
                    <>
                        {children}
                        {hasLine && <hr />}
                        {!disableButtons && (
                            <ButtonContainer style={{ marginTop: '1rem' }}>
                                <ButtonWrapper>
                                    <ConfirmButton
                                        label={initialData ? 'Változtatások mentése' : 'Mentés'}
                                        icon="pi pi-check"
                                        type="submit"
                                    />
                                    <CancelButton label="Mégsem" icon="pi pi-times" type="button" onClick={onClose} />
                                </ButtonWrapper>
                            </ButtonContainer>
                        )}
                    </>
                )}
            </div>
        </FormContainer>
    )
}
